module.exports = __webpack_public_path__ + "static/media/Kayn_0.464e3a85.jpg";